export default "__VITE_ASSET__669f46e1__"